// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2CsE5","emails":"CreateEditClinics_emails__2oJJQ","emailTagLabel":"CreateEditClinics_emailTagLabel__2L0TQ"};